<template>
    <div id="ShowErr">
    </div>
</template>

<script>

export default {
  name: 'ShowErr',
  data: function() {
    return {
        msg: ''
    }
  },
  mounted() {
    this.msg = this.$rmEncHyp(this.$route.query.msg);
    //this.msg = this.$route.query.msg;
    this.showErr();
  },
  methods: {
    showErr() {
        this.$showErr(this.msg);
        //this.$router.push({ path: '/' });
    }
  }

}

</script>

<style scoped>
</style>

